import List from "@/components/treeList";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  // function showDetail({ row }) {
  //   Bus.$emit("details", row);
  // }
  function handleUpdate({ row }) {
    Bus.$emit("ReceiveMessage", Object.assign({}, row));
  }
  //删除
  function handleDelete({ row }) {
    Bus.$emit("deleteDept", row);
  }
  // //上移
  // function moveUp({ row }, flag) {
  //   if (flag) {
  //     Bus.$emit("moveUp", row);
  //   } else return;
  // }
  // //下移
  // function moveDown({ row }, flag) {
  //   if (flag) {
  //     Bus.$emit("moveDown", row);
  //   } else return;
  // }
  // //置顶
  // function moveTop({ row }, flag) {
  //   if (flag) {
  //     Bus.$emit("moveTop", row);
  //   } else return;
  // }
  // const Move = ({ props: { vo } }) => {
  //   const dealConf = [];
  //   if (vo.row.headAndHail == "0" || vo.row.headAndHail == "01") {
  //     dealConf.push([
  //       "上移",
  //       () => moveUp(vo, false),
  //       "dept:upAndDown",
  //       "disabled"
  //     ]);
  //   } else {
  //     dealConf.push(["上移", () => moveUp(vo, true), "dept:upAndDown", "able"]);
  //   }
  //   if (vo.row.headAndHail == "1" || vo.row.headAndHail == "01") {
  //     dealConf.push([
  //       "下移",
  //       () => moveDown(vo, false),
  //       "dept:upAndDown",
  //       "disabled"
  //     ]);
  //   } else {
  //     dealConf.push([
  //       "下移",
  //       () => moveDown(vo, true),
  //       "dept:upAndDown",
  //       "able"
  //     ]);
  //   }
  //   if (vo.row.level == 1 && vo.$index !== 0) {
  //     dealConf.unshift([
  //       "置顶",
  //       () => moveTop(vo, true),
  //       "dept:upAndDown",
  //       "able"
  //     ]);
  //   } else if (vo.row.level == 1 && vo.$index == 0) {
  //     dealConf.unshift([
  //       "置顶",
  //       () => moveTop(vo, false),
  //       "dept:upAndDown",
  //       "disabled"
  //     ]);
  //   }
  //   // v-permission={item[2]}
  //   return (
  //     <div class="deal-group">
  //       {dealConf.map(item => (
  //         <span
  //           class={item[3] == "disabled" ? "disabled" : "deal-btn"}
  //           onClick={item[1]}
  //           v-permission={item[2]}
  //         >
  //           {item[0]}
  //         </span>
  //       ))}
  //     </div>
  //   );
  // };
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "dept:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "dept:delete"]
    ];
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "学院名称",
      prop: "name",
      minWidth: "160",
      showOverflowTooltip: true
    },
    {
      label: "学院属性",
      prop: "unitAttrName",
      minWidth: "130"
    },
    {
      label: "属性类别",
      prop: "attrCategoryName",
      minWidth: "130"
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "150"
    },
    // {
    //   label: "排序",
    //   prop: "order",
    //   minWidth: "180",
    //   render: vo => <Move vo={vo} />
    // },
    {
      label: "操作",
      fixed: "right",
      minWidth: "130",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
